import {Select, Text} from '@mantine/core';
import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import {MdOpenInNew} from 'react-icons/md';
import {
  COLOR_BACKGROUND_1,
  COLOR_PRIMARY_1,
} from '../../../../../config/constants/colorCodes';
import {cn} from '../../../../../lib/classname';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import type {Heading} from '../../../usecase/useCompanyDetailContents';

type Props = {
  companyId: number;
  hasReports: boolean;
  headerContents: Heading[];
  isValid: boolean;
  availableGraduationYears?: number[];
  year: string;
  className?: string;
};

export const ContentNavigationBar: React.FC<Props> = ({
  companyId,
  hasReports,
  headerContents,
  isValid,
  availableGraduationYears,
  year,
  className,
}) => {
  const [potionTop, setPotionTop] = useState('top-[150px]');
  const router = useRouter();

  useEffect(() => {
    if (isValid) {
      setPotionTop('top-[100px]');
    }
  }, [isValid]);
  return (
    <div className={cn('sticky my-16 z-40', potionTop, className)}>
      <div className="p-16 flex justify-between bg-white rounded-16 shadow-card">
        <div className="pc:flex pc:gap-8">
          {headerContents.map((item) => (
            <CommonLink key={item.id} href={`#${item.id}`}>
              <div className="rounded-16 p-8 text-primary-1 text-base font-bold pc:bg-background hover:opacity-70">
                <Text>{item.tagname}</Text>
              </div>
            </CommonLink>
          ))}
          {hasReports && (
            <CommonLink
              key={'header-contents-reports'}
              href={`/company/${companyId}/experiences`}
              target="_blank"
            >
              <div className="rounded-16 p-8 text-primary-1 text-base font-bold pc:bg-background hover:opacity-70">
                <Text>
                  <span className="flex items-center gap-4">
                    ES・体験記
                    <MdOpenInNew />
                  </span>
                </Text>
              </div>
            </CommonLink>
          )}
        </div>
        {!isValid &&
          availableGraduationYears &&
          availableGraduationYears.length > 0 && (
            <Select
              className={`${isValid && 'hidden'}`}
              placeholder="卒年を選択"
              defaultValue={year}
              data={availableGraduationYears?.map((item) => {
                return {value: String(item), label: `${item}年卒`};
              })}
              onChange={(value) => {
                router.push(`/company/${companyId}/${value}`);
              }}
              styles={{
                input: {
                  backgroundColor: COLOR_BACKGROUND_1,
                  borderRadius: 16,
                  borderWidth: 0,
                  color: COLOR_PRIMARY_1,
                  fontWeight: 'bold',
                  width: 128,
                },
              }}
            />
          )}
      </div>
    </div>
  );
};
